import React, { FC } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { MuiThemeProvider } from '@material-ui/core/styles';
import RootLayout from './screens/RootLayout';
import MuiTheme from './MuiTheme';
import AppToastProvider from 'Components/Toast/AppToast';
import AppDialogProvider from 'Components/Dialogs/AppDialogProvider';

const App: FC = () => {

    return (
        <BrowserRouter>
            <MuiThemeProvider theme={MuiTheme} >
                <AppToastProvider>
                    <AppDialogProvider>
                        <RootLayout />
                    </AppDialogProvider>
                </AppToastProvider>
            </MuiThemeProvider>
        </BrowserRouter>
    );
}

export default App;
